import { useMutation } from '@tanstack/react-query';
import { ModelPrimaryKey } from '@steelbuy/ts-shared';
import axios from '../../axios';

const deleteListingDraft = async (draftId: ModelPrimaryKey) => {
    const { data } = await axios.delete<ModelPrimaryKey>(`/api/seller/draft-listings/${draftId}`);
    return data;
};

export const useDeleteListingDraft = () =>
    useMutation({
        mutationFn: (draftId: ModelPrimaryKey) => deleteListingDraft(draftId),
    });
